/* eslint-disable @typescript-eslint/no-explicit-any */
import '@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css';

import { Calendar, DayValue, utils } from '@hassanmojab/react-modern-calendar-datepicker';
import React from 'react';

import { locale } from '../utils/locale';
import Modal from './Modal';

const ModalCalendar = (props: {
  currentIndex: number;
  startDate: DayValue;
  title: string;
  description: string;
  cancelButtonRef: React.MutableRefObject<null>;
  isShowModal: boolean;
  isLoading?: boolean;
  closeModal?: () => void;
  closeModalBackground: () => void;
  handleProductChange: (
    index: number,
    value: any,
    type: 'product' | 'count' | 'images' | 'date'
  ) => void;
}) => {
  const footer = () => {
    return (
      <div
        onClick={props.closeModal}
        className="text-regular text-primary-green font-interSemiBold ">
        Batal
      </div>
    );
  };
  return (
    <Modal
      cancelButtonRef={props.cancelButtonRef}
      isShowModal={props.isShowModal}
      closeModalBackground={props.closeModalBackground}>
      <div className="border-b border-gray-gray200 pb-4">
        <div className="text-medium text-gray-gray700 font-interMedium mb-2">{props.title}</div>
        <div className="text-small text-gray-gray600 font-interLight">{props.description}</div>
      </div>
      <Calendar
        value={props.startDate}
        onChange={(selectedDate: DayValue) => {
          props.closeModal();
          props.handleProductChange(props.currentIndex, selectedDate, 'date');
        }}
        shouldHighlightWeekends
        minimumDate={utils('en').getToday()}
        colorPrimary="#006551"
        locale={locale}
        calendarTodayClassName="bg-positive-lighter"
        renderFooter={footer}
      />
    </Modal>
  );
};

export default ModalCalendar;
